import { call, put } from 'redux-saga/effects';

import { extractErrorMessage, sendToLogger } from 'connect/saga/helpers';
import { apiGetOffer } from 'endpoints/match-endpoints';

import { SagaHandler } from '../SagaHandler';

class _RequestOffer extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/REQUEST_OFFER',
      stateKey: 'requestOffer',
      legacyOptions: {
        valueStateKey: 'offer',
      },
      dependencies: [
        'data/REQUEST_REFFERAL_PROMOTION',
        'api/UPDATE_ANONYMOUS_SESSION_DATA',
      ],
    });
  }

  * saga({ payload }) {
    const offerCode = payload;
    const errorHandler = this.error;
    const loadingHandler = this.loading;
    const valueHandler = this.value;

    try {
      yield put(loadingHandler.update(true));
      yield put(errorHandler.update(null));
      const offer = yield call(apiGetOffer, offerCode);
      yield put(valueHandler.update(offer));

      const requestReferralPromotion = this._dependencies.data.REQUEST_REFFERAL_PROMOTION;
      yield put(requestReferralPromotion.value.update(null));

      // Save offer code to anonymous session data
      const appendAnonymousSessionData = this._dependencies.api.UPDATE_ANONYMOUS_SESSION_DATA;
      yield call(
        appendAnonymousSessionData.saga,
        appendAnonymousSessionData.createAction({
          offer: {
            slug: offerCode,
          },
        }),
      );
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      sendToLogger(error, 'requestOffer');
      yield put(errorHandler.update(errorMessage));
    } finally {
      yield put(loadingHandler.update(false));
    }
  }
}

export const RequestOffer = new _RequestOffer();
